import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { fetchChangelog, setLastSeenChangelogId } from "utils/changelogService";
import ChangelogEntryList from "components/WhatsNew/ChangelogEntryList";

const WhatsNew = () => {
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const data = await fetchChangelog();
      setEntries(data);
      setIsLoading(false);
      if (data.length > 0) setLastSeenChangelogId(data[0].id);
    })();
  }, []);

  return (
    <div className="flex flex-wrap mt-4 dashBody">
      <div className="w-full mb-12 px-4">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 p-4 md:p-6 shadow-lg rounded-xl bg-app-surface text-app-text">
          <div className="mb-6 pb-4 border-b border-app-border">
            <h2 className="text-2xl font-semibold text-app-text">What's new</h2>
            <p className="text-sm text-app-text-muted mt-1">
              A running log of what's changed as updates move from staging into the live dashboard.
            </p>
          </div>

          {isLoading ? (
            <div className="flex justify-center items-center min-h-[240px]">
              <CircularProgress size={48} />
            </div>
          ) : (
            <div className="max-w-2xl">
              <ChangelogEntryList
                entries={entries}
                emptyMessage="No release notes have been published yet."
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsNew;
